module.exports = __webpack_public_path__ + "assets/img/tit4.cc9f363d.png";